import styled from 'styled-components';

export const StyledMyAuditConductContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 88px;
  margin-bottom: 88px;
`;

export const MyAuditConductSearchBarContainer = styled.div`
  margin: ${({ theme }) => theme.spacing.m} 0;
`;

export const ModalHeader = styled.div`
  text-align: center;
  margin: 16px 0;
`;

export const ModalContent = styled.div`
  text-align: justify;
  margin: 16px;
`;

export const MyAuditCommentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.m};
`;

export const ScoreContainer = styled.div`
  margin: ${({ theme }) => theme.spacing.m} 0;
`;

export const MyAuditConductButtonContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.m};
  margin: 0 ${({ theme }) => theme.spacing.m};
`;

export const DatePickerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.s};
  margin: ${({ theme }) => theme.spacing.m} ${({ theme }) => theme.spacing.none};
`;
